import { render, staticRenderFns } from "./PersonalPortfolio.vue?vue&type=template&id=8049af9e&"
import script from "./PersonalPortfolio.vue?vue&type=script&lang=js&"
export * from "./PersonalPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports